import React from 'react'
import { Result, Button } from 'antd'
import { withRouter } from 'react-router-dom'

const backtoHome = (props) => {
    const { history } = props
    history.push('/')
}

const PageNotFound = (props) => {
        return (
            <React.Fragment>
                <Result
                  status="404"
                  title="404"
                  subTitle="Sorry, the page you visited does not exist."
                  extra={<Button type="primary" onClick={e => backtoHome(props)}>Back Home</Button>}
                />
            </React.Fragment>
        )
}

export default withRouter(PageNotFound)